export default {
  users: 'users',
  widgets: 'widgets',
  teams: 'teams',
  workbooks: 'workbooks',
  projects: 'projects'
};